import { render, staticRenderFns } from "./DayButton.vue?vue&type=template&id=55b024c5"
import script from "./DayButton.vue?vue&type=script&lang=ts"
export * from "./DayButton.vue?vue&type=script&lang=ts"
import style0 from "./DayButton.vue?vue&type=style&index=0&id=55b024c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports